import { Component } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { Router, RouterModule } from '@angular/router';
import { CommonModule } from '@angular/common';
import { AnalitycsService } from '../../service/analitycs.service';
import moment from 'moment';

@Component({
  selector: 'app-download',
  templateUrl: './app-download.component.html',
  styleUrls: ['./app-download.component.css'],
  standalone: true,
  imports: [CommonModule, RouterModule, TranslateModule],
})
export class AppDownloadComponent {
  currentYear = new Date().getFullYear();

  constructor(
    private analitycs: AnalitycsService,
    private router: Router,
  ) {
    // do nothing
  }

  ngOnInit() {
    this.analitycs.logEvent('Visitar_pagina_descarga_App', {
      pantalla: 'app-download',
      accion: 'ver',
      timestamp: moment().format('YYYY-MM-DD HH:mm:ss'),
      plataforma: 'web',
    });
  }

  downloadIOS() {
    this.analitycs.logEvent('descarga_app_ios', {
      pantalla: 'app-download',
      accion: 'clic',
      timestamp: moment().format('YYYY-MM-DD HH:mm:ss'),
      plataforma: 'web',
    });

    // La app de iOS aún no está disponible, por lo que no hacemos ninguna redirección
    window.open('https://apps.apple.com/us/app/pitzon/id6753827314', '_blank');
  }

  downloadAndroid() {
    this.analitycs.logEvent('descarga_app_android', {
      pantalla: 'app-download',
      accion: 'clic',
      timestamp: moment().format('YYYY-MM-DD HH:mm:ss'),
      plataforma: 'web',
    });
    // Aquí puede ir la lógica para redirigir a Google Play
    window.open('https://play.google.com/store/apps/details?id=io.pitzonapp.app&hl=es_CO', '_blank');
    // https://play.google.com/store/apps/details?id=io.pitzonapp.app
  }
  goBack() {
    this.router.navigate(['/']);
  }
}
